export const setRouterName = (state, payload) => state.router = payload;
